import _ from 'lodash'

import config from '../../config'

import {
    LOGIN,
    LOGIN_REQUEST,
    LOGOUT,
    LOGOUT_REQUEST,
    USER_INFO_REQUEST,
    AVAILABLE_MODULES_REQUEST,
    SET_LOADING,
    SET_AUTHORIZE,
} from './constants'

// if username and password and redirectModule are null, try autologin
// if username and password are null and redirectModule
export function login(options) {
    const o = _.merge(
        {
            username: null,
            password: null,
            sessionId: null,
            uniqueId: null,
            redirectModule: null,
            id: null,
            language: null,
            autologin: false,
        },
        options
    )

    return {
        type: LOGIN,
        data: {
            ...o,
        },
    }
}

export function loginRequest(username, password) {
    return {
        type: LOGIN_REQUEST,
        payload: {
            ...config.api.login,
            formData: `user_name=${encodeURIComponent(username)}&password=${encodeURIComponent(
                password
            )}&replace_existing=true`,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
        },
    }
}

export function logout() {
    return {
        type: LOGOUT,
    }
}

export function logoutRequest() {
    return {
        type: LOGOUT_REQUEST,
        payload: {
            ...config.api.logout,
            headers: {
                Accept: 'text/plain',
            },
        },
    }
}

export function setLoading(isLoading = false) {
    return {
        type: SET_LOADING,
        data: {
            isLoading,
        },
    }
}

export function setAuthorize(isAuthorized = false) {
    return {
        type: SET_AUTHORIZE,
        data: {
            isAuthorized,
        },
    }
}

export function userInfoRequest(sessionId) {
    return {
        type: USER_INFO_REQUEST,
        payload: {
            ...config.api.userInfo,
            headers: {
                sid: `gnosus/${sessionId}`,
            },
            qs: {
                sid: sessionId,
            },
        },
    }
}

export function availableModulesRequest(sessionId) {
    return {
        type: AVAILABLE_MODULES_REQUEST,
        payload: {
            ...config.api.availableModules,
            qs: {
                sid: sessionId,
            },
        },
    }
}
